import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Modal,
  Button,
  Row,
  Col,
  Card,
  Space,
  Input,
  Tag,
  Radio,
  Form,
  Select,
} from "antd";
import {
  BuildOutlined,
  EnvironmentOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

function InvoiceModal(props) {
  const { Option } = Select;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [clientName, setClientName] = useState(
    props?.initialClientName || null
  );
  const [workOrder, setWorkOrder] = useState(props?.initialWorkOrder || null);
  const selectedLanguage = localStorage.getItem("selectedlanguage");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invoiceType, setInvoiceType] = useState(null);
  const [depositValue, setDepositValue] = useState("");
  const [partialPaidInput, setPartialPaidInput] = useState("");
  const [partialDueInput, setPartialDueInput] = useState("");
  const [depositUnit, setDepositUnit] = useState("%");
  const [paidUnit, setPaidUnit] = useState("%");
  const [dueUnit, setDueUnit] = useState("%");
  const { companyId, clientId, partnerId, workOrderId } = useParams();
  // const [errorMessage, setErrorMessage] = useState("");

  const workOrderDetails = useSelector(
    (state) => state.clients.workOrderDetails
  );
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );

  // Example values from backend
  const totalAmount = workOrderDetails?.grandTotal || 0;
  const totalPaid = workOrderDetails?.totalPaidAmount || 0;
  const dueAmount = totalAmount - totalPaid;

  const unitOptions = [
    { label: "%", value: "%" },
    { label: "Amount", value: "Amount" },
  ];

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr?.address1,
      addr?.address2,
      addr?.city,
      provinceName,
      countryName,
      addr?.zip,
    ].filter(Boolean);

    const line1 = [addr?.address1, addr?.address2, addr?.city]
      .filter(Boolean)
      .join(", ");
    const line2 = [provinceName, countryName, addr?.zip]
      .filter(Boolean)
      .join(", ");

    return (
      <>
        {line1}
        <br />
        {line2}
      </>
    );
  };

  const handleGenerate = () => {
    if (invoiceType == "WorkOrder") {
      navigate(
        partnerId && clientId
          ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/wo_details/${workOrderId}/generateinvoice`
          : clientId
          ? `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}/generateinvoice`
          : `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}/generateinvoice`
      );
    } else if (invoiceType == "AdditionalItems") {
      navigate(
        partnerId && clientId
          ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/wo_details/${workOrderId}/generateadditionalinvoice`
          : clientId
          ? `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}/generateadditionalinvoice`
          : `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}/generateadditionalinvoice`
      );
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setClientName(null);
    setWorkOrder(null);
    form.resetFields();
  };
  // const handlePartialPaidChange = (e) => {
  //   const value = e.target.value;

  //   // Allow only numbers and decimals
  //   let numericValue = Number(value);
  //   let error = "";

  //   if (paidUnit === "%") {
  //     if (numericValue > 100) {
  //       error = "Percentage cannot exceed 100%";
  //       numericValue = 100;
  //     }
  //     // Convert % to amount
  //     numericValue = (numericValue / 100) * dueAmount;
  //   } else if (paidUnit === "Amount") {
  //     if (numericValue > dueAmount) {
  //       error = `Amount cannot exceed Due ($${dueAmount})`;
  //       numericValue = dueAmount;
  //     }
  //   }

  //   setErrorMessage(error);
  //   setPartialPaidInput(numericValue.toFixed(2));
  // };

  useEffect(() => {
    setClientName(props?.initialClientName || null);
    setWorkOrder(props?.initialWorkOrder || null);
  }, [props?.initialClientName, props?.initialWorkOrder]);

  const handleSelect = (isSelected, key) => {
    setSelectedRowKeys((prev) =>
      isSelected ? [...prev, key] : prev.filter((k) => k !== key)
    );
  };
  const handleFormChange = () => {
    const values = form.getFieldsValue();
    setClientName(values.clientName || null);
    setWorkOrder(values.workOrder || null);
  };
  const renderLeftSide = () => (
    <>
      <Card className="clientview-new">
        <h1>{workOrderDetails?.woNumber}</h1>
        <Space direction="vertical" size={8} className="mt-5px">
          <h5>Work Order Details</h5>
          <p>
            <BuildOutlined />{" "}
            {workOrderDetails?.partnerId != null
              ? workOrderDetails?.partnerName
              : workOrderDetails?.clientName}
          </p>
          <p>
            <EnvironmentOutlined />{" "}
            {workOrderDetails?.companyAddress ? (
              <span>{renderAddress(workOrderDetails?.companyAddress)}</span>
            ) : null}
          </p>
        </Space>
      </Card>
    </>
  );

  return (
    <>
      <Button type="primary" variant="solid" onClick={showModal}>
        <PlusCircleOutlined />
        Generate Invoice
      </Button>
      <Modal
        title="Generate Invoice"
        open={isModalOpen}
        onCancel={handleCancel}
        width={900}
        centered
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="generate"
            type="primary"
            onClick={handleGenerate}
            //disabled={errorMessage}
          >
            Generate Invoice
          </Button>,
        ]}
        styles={{
          body: { maxHeight: "500px" },
        }}
      >
        <Row gutter={16}>
          {/* Left Side */}
          <Col span={8}>
            {renderLeftSide()}
            {/* <p style={{ fontSize: "12px" }} className="mt-20">
              <span className="text-danger">Note:</span> Only completed
              appointments are displayed for invoicing
            </p> */}
          </Col>

          {/* Right Side */}
          <Col span={16}>
            <div
              style={{
                paddingLeft: "16px",
                borderLeft: "1px solid #f0f0f0",
                borderRadius: "8px",
                minHeight: "200px",
              }}
            >
              <div style={{ marginTop: "20px" }}>
                {/* Partial Payments Section */}
                <div style={{ marginLeft: "24px" }}>
                  {/* Display Paid & Due */}
                  <div
                    style={{
                      display: "flex",
                      gap: "24px",
                      marginBottom: "10px",
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      <strong>Total Amount:</strong> ${totalAmount.toFixed(2)}
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Paid:</strong> ${totalPaid.toFixed(2)}
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Due:</strong> ${dueAmount.toFixed(2)}
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Deposit:</strong> $
                      {(workOrderDetails?.depositAmount ?? 0).toFixed(2)}
                    </p>
                  </div>

                  <Radio.Group
                    value={invoiceType}
                    onChange={(e) => setInvoiceType(e.target.value)}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <Radio value="WorkOrder">
                      Generate Invoice (Work Order)
                    </Radio>

                    <Radio value="AdditionalItems">Additional Items</Radio>
                  </Radio.Group>
                </div>
                <p style={{ color: "red", marginTop: "16px" }}>
                  <FormattedMessage id="Invoice.WorkOrdercontainsadditionalproducts" />{" "}
                </p>
              </div>
            </div>
          </Col>

          {/* <Col span={16}>
            <div
              style={{
                paddingLeft: "16px",
                borderLeft: "1px solid #f0f0f0",
                borderRadius: "8px",
                minHeight: "200px",
              }}
            >
              <div style={{ marginTop: "20px" }}>
                <Radio.Group
                  onChange={(e) => setPaymentType(e.target.value)}
                  value={paymentType}
                >
                  <Space direction="vertical">
                    <Radio value="deposit">Deposit</Radio>
                    {paymentType === "deposit" && (
                      <div style={{ marginLeft: "24px" }}>
                        <Space.Compact style={{ width: "100%" }}>
                          <Select
                            value={depositUnit}
                            onChange={setDepositUnit}
                            options={unitOptions}
                            style={{ width: 150 }}
                          />
                          <Input
                            placeholder={`Enter ${depositUnit}`}
                            value={depositValue}
                            onChange={(e) => setDepositValue(e.target.value)}
                          />
                        </Space.Compact>
                      </div>
                    )}

                    <Radio value="partial">Partial Payments</Radio>
                    {paymentType === "partial" && (
                      <div style={{ marginLeft: "24px" }}>
                        <div
                          style={{
                            display: "flex",
                            gap: "24px",
                            marginBottom: "10px",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            <strong>Paid:</strong> ${paidAmount}
                          </p>
                          <p style={{ margin: 0 }}>
                            <strong>Due:</strong> ${dueAmount}
                          </p>
                        </div>
                        <div style={{ display: "flex", gap: "12px" }}>
                          <Space.Compact style={{ width: "100%" }}>
                            <Select
                              value={paidUnit}
                              onChange={setPaidUnit}
                              options={unitOptions}
                              style={{ width: 150 }}
                            />
                            <Input
                              placeholder={`Enter Paid ${paidUnit}`}
                              value={partialPaidInput}
                              onChange={(e) =>
                                setPartialPaidInput(e.target.value)
                              }
                            />
                          </Space.Compact>
                        </div>
                      </div>
                    )}
                  </Space>
                </Radio.Group>
              </div>
            </div>
          </Col> */}
        </Row>
      </Modal>
    </>
  );
}

export default InvoiceModal;
